module.exports = __webpack_public_path__ + "static/media/Nguyen_Trung_Thanh.60251931.png";